import { NotificationBaseViewModel } from "../../notification/Notification.types";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useNavMenuDataMapping() {
    const url = "/notification/notifications";
    let { isLoading, data, refetch } = useDotLegalQuery<Array<NotificationBaseViewModel>>(url);

    let showNotification = (data && data?.filter((not) => not.isRead === false).length > 0) ?? false;

    return {
        showNotification,
        notifications: data,
        isLoading,
        refetchMenuNotifications: refetch,
    };
}
